const sideMenu = [
    { label: 'Beranda', url: '/', icon: 'fas fa-home' },
    { label: 'Profil', url: '/profile', icon: 'fas fa-user' },
    { label: 'Tentang', url: '/about', icon: 'fas fa-building' },
    { label: 'Logout', url: '/logout', icon: 'fa fa-sign-out-alt' },

];
export default sideMenu;
